import { Stack, Typography } from "@mui/material";
import { FC } from "react";

import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { TProduct } from "@/api/services/main/organization/product/dtos/product.dto";

type TDeleteProductsModalProps = {
  isOpen: boolean;
  /** Products about to be deleted (already filtered to deletable, non-default rows). */
  targets: TProduct[];
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/** Confirmation dialog for deleting the selected products. */
export const DeleteProductsModal: FC<TDeleteProductsModalProps> = ({ isOpen, targets, isDeleting, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      title="商品の削除"
      labelClose="キャンセル"
      labelOk="削除する"
      isLoadingOkBtn={isDeleting}
      onClose={onClose}
      onOk={onConfirm}
    >
      <Stack gap={1.5} py={1}>
        <Typography variant="body14" color={text.primary}>
          選択した{targets.length}件の商品を削除します。この操作は取り消せません。
        </Typography>
        <Stack component="ul" gap={0.5} pl={2} m={0}>
          {targets.map((product) => (
            <Typography key={product.id} component="li" variant="body14Semi" color={text.primary}>
              {product.name}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};
